<div class="box">

  <app-age></app-age>

  <app-bars></app-bars>

  <app-display></app-display>

  @if (statesService.progress) {
    <app-progress-bar></app-progress-bar>
  }

  @if (simulation.pet != null && !statesService.states.activeAnimation) {
    <app-button-row class="row"></app-button-row>
  }

</div>
